module.exports = __webpack_public_path__ + "static/img/kjgl2.e5c808f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/kjgl2.png
// module id = A/op
// module chunks = 1